import {AfterViewInit, Component, OnInit} from '@angular/core';
import {redirectToLink} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SessionService} from '../../../services/session.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-cumplimiento-juridico',
    templateUrl: './cumplimiento-juridico.component.html',
    styleUrls: ['./cumplimiento-juridico.component.scss']
})
export class CumplimientoJuridicoComponent implements AfterViewInit, OnInit {
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private deviceService: DeviceDetectorService,
        private sessionService: SessionService,
        private router: Router
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
    }

    ngAfterViewInit(): void {
    }

    goTo(link): void {
        redirectToLink(link);
    }

    ngOnInit(): void {
    }

    enviarDownloadCumplimiento(country: string): void {
        this.sessionService.setDownloadCumplimiento(country);
        this.router.navigate(['cumplimiento-juridico-de-la-firma-digital/descarga-el-tuyo']);
    }
}
